import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { useLang } from '@/i18n';
import { redirectTo404 } from '@/utils';
import Oasis from '@elem/compPage/Oasis';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { IPageStatus } from '@elem/compPage/Oasis/config/IPageStatus';

const whiteLocaleList = ['us', 'ca', 'eu', 'uk', 'de', 'es', 'fr', 'it', 'nl'];
const isPrd = process.env.NEXT_PUBLIC_MODY === 'prd'; //是否是生产环境
export default function Page({ SEO }: any) {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('Oasis');
    return (
        <>
            <PageLayout isNoFixed={true} theme="black">
                <SEO title={t('seo_title')} description={t('seo_desc')} />
                <SEOlinksA locale={locale} list={whiteLocaleList} pathname={'oasis-home-energy-management-system1'} />
                <Oasis />
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    const { debug, _timer } = query;
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    let data = null;
    try {
        data = require(`elem/compPage/Oasis/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/Oasis/config/times/eu.js`);
    }

    const timeLine = data.timeLine || null; // 代码保存的时间线

    // 时间节点判断 正式环境未开始重定向404

    let systemTime = new Date().getTime(); // 系统时间
    if (_timer) {
        // 读取url上的时间进行测试
        const _timer2 = `${_timer} GMT+8`;
        systemTime = new Date(_timer2).getTime();
    }

    // 当前阶段
    let pageStatus = IPageStatus.statusA;
    if (debug) {
        // 是否进入调试状态
        pageStatus = debug as any;
    } else if (timeLine) {
        if (systemTime >= timeLine?.statusA?.start) {
            // 系统时间进入 statusA 时间段
            pageStatus = IPageStatus.statusA;
        } else if (isPrd && locale !== 'us' && locale !== 'ca') {
            //欧洲六站加上定时发布，北美不需要
            // 系统时间不在上述时间段,且进入生产环境才跳转404
            return redirectTo404();
        }
    }
    return {
        props: {
            pageStatus,
        },
    };
}
